import Default from '@/Layouts/Default.vue'
import Unauthenticated from '@/Layouts/Unauthenticated.vue'
import LandingPage from './LandingPage.vue'

export default {
  Default,
  Unauthenticated,
  LandingPage,
}
